import React, { Children } from 'react';

import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

const ActiveLink = ({
  className, children, activeClassName, exactActiveClassName, childLinks, ...props
}) => {
  const { asPath } = useRouter();
  const isExactActive = asPath === props.href || asPath === props.as;
  const isActive = (props.href && asPath.startsWith(props.href))
    || (props.as && asPath.startsWith(props.as))
    || childLinks?.some?.((href) => asPath.startsWith(href));

  const claz = cn({
    cn: className,
    [exactActiveClassName]: isExactActive,
    [activeClassName]: isActive,
  });

  return (
    <Link {...props} className={claz || null}>
      {children}
    </Link>
  );
};

ActiveLink.propTypes = {
  activeClassName: PropTypes.string.isRequired,
};

export default ActiveLink;
